import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_USERS = "/api/users"
export const ENDPOINT_MY_PROFILE = "/api/my_profile"

export async function getUsers(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_USERS
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getUser(id) {
  let url = REACT_APP_API_URL + ENDPOINT_USERS + "/" + id
  return await getObject(url)
}

export async function putUser(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_USERS + "/" + id
  return await putObject(url, putValues)
}

export async function patchUser(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_USERS + "/" + id
  return await patchObject(url, patchValues)
}

export async function postUser(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_USERS
  return await postObject(url, postValues)
}

export async function getMyProfile() {
  let url = REACT_APP_API_URL + ENDPOINT_MY_PROFILE
  return await getObject(url)
}
